<!-- Payment Integrations Filters - Following customers-filters pattern -->
<div class="payment-integrations-filters" [class.drawer-mode]="drawerMode">
  <!-- Header with Filters title and Clear All button -->
  <div class="filters-header-main" [ngClass]="drawerMode ? 'p-3' : 'mb-3'">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-filter text-gray-600 mr-2"></i>
        <h2 class="filters-title">Filters</h2>
      </div>
      <!-- Clear All button - always visible -->
      <div class="header-right">
        <button
          class="clear-all-btn"
          [disabled]="loading || !hasActiveFilters"
          [class.has-filters]="hasActiveFilters"
          (click)="onClearFilters()"
          title="Clear all active filters"
        >
          Clear All
        </button>
      </div>
    </div>
  </div>

  <!-- Scrollable Filter Content Container -->
  <div
    class="filters-content-scroll"
    [ngClass]="drawerMode ? 'drawer-scroll' : 'default-scroll'"
  >
    <!-- ID Filter Section -->
    <div class="filter-section" [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'">
      <div class="section-header mb-2">
        <label for="filterId" class="filter-section-title">ID</label>
      </div>
      <p-inputNumber
        id="filterId"
        [formControl]="filterForm.controls.clientFilterId"
        placeholder="Filter by ID"
        [showButtons]="false"
        [useGrouping]="false"
        styleClass="w-full"
        inputStyleClass="w-full"
      />
    </div>

    <!-- Name/Account Filter Section -->
    <div class="filter-section" [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'">
      <div class="section-header mb-2">
        <label for="filterName" class="filter-section-title"
          >Name / Account</label
        >
      </div>
      <div class="search-input-wrapper">
        <p-iconfield iconPosition="left" styleClass="w-full">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            id="filterName"
            type="text"
            pInputText
            [formControl]="filterForm.controls.clientFilterName"
            placeholder="Search by name or account"
            class="w-full"
          />
        </p-iconfield>
      </div>
    </div>

    <!-- Provider Filter Section -->
    <div class="filter-section" [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'">
      <div class="section-header mb-2">
        <label for="filterProvider" class="filter-section-title"
          >Provider</label
        >
      </div>
      <p-dropdown
        id="filterProvider"
        [formControl]="filterForm.controls.clientFilterProvider"
        [options]="paymentMethodOptions"
        placeholder="All Providers"
        [showClear]="true"
        [filter]="true"
        filterPlaceholder="Search providers..."
        styleClass="w-full"
        appendTo="body"
      />
    </div>

    <!-- Test Mode Filter Section -->
    <div class="filter-section" [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'">
      <div class="section-header mb-2">
        <span class="filter-section-title">Test Mode</span>
      </div>
      <p-selectButton
        [formControl]="filterForm.controls.clientFilterTestMode"
        [options]="testModeOptions"
        optionLabel="label"
        optionValue="value"
        styleClass="w-full test-mode-buttons"
      />
    </div>
  </div>
</div>
